import clsx from 'clsx';
import { MedalIcon } from 'lucide-react';
import { AccessibleIcon } from 'radix-ui';

export function Medal({
  position,
  className,
}: {
  position: number;
  className?: string;
}) {
  const medalData: Record<number, { label: string; colorClassName: string }> = {
    1: { label: 'Medalla de oro', colorClassName: 'stroke-yellow-400' },
    2: { label: 'Medalla de plata', colorClassName: 'stroke-slate-400' },
    3: { label: 'Medalla de bronce', colorClassName: 'stroke-orange-400' },
  };

  const { label, colorClassName } = medalData[position];

  return (
    <AccessibleIcon.Root label={label}>
      <MedalIcon
        className={clsx('fill-background', colorClassName, className)}
      />
    </AccessibleIcon.Root>
  );
}
